import React, {
  useState
}                                       from 'react';
import { historyPropType }              from '~/config/routerPropTypes';
import {
  createCards,
  showCards
}                                       from '~/config/routes';
import Request                          from '~/providers/Request';
import CardRecord                       from '~/records/CardRecord';
import Form                             from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new CardRecord());
  const [ loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    let archive_id = record.get('archive_id') ? record.get('archive_id') : null;
    const imageBase64 = record.get('image_base64');
    setLoading(true);
    if(imageBase64){
      try {
        const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}` });
        archive_id = result.data.id;
      } catch(e) {console.log(e);}
    }

    const data = record.toParams({archive_id});
    Request.post('/admin/promo_cards', data, {}, { controller: 'cards' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue){
          history.push(createCards.spec);
        } else{
          history.push(showCards.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={(saveAndContinue) => onSubmit(saveAndContinue)}
      setRecord={setRecord}
      record={record}
      handleChange={handleChange}
      loading={loading}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
